<!--
  @description 数据配置-新增、编辑页
  @author xiehan
  @date 2018/12/11
-->
<template>
  <div class="handlerDataConfig__content">
    <g-back :history="history"></g-back>
    <el-form ref="handleForm" :model="handleForm" label-width="90px" :rules="rules">
      <el-form-item :label="$t('dataConfig.name')" prop="name">
        <el-input v-model="handleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$t('dataConfig.name')">
        <g-select v-model="handleForm.type" :list="select_type"></g-select>
      </el-form-item>
    </el-form>
    <dial ref="dataConfigDial" @testSingleDial="testSingleDial"></dial>
    <el-form label-width="90px">
      <el-form-item>
        <el-button type="primary"
          class="mt-base"
          @click="saveSource"
          v-g-rac="gRac('dataConfigEdit_save')"
          v-text="$t('common.save')"></el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import dial from '@/views/component/dial/dial.vue'
  import dialBiz from '@/logic/intelligentMonitor/dialBiz'
  import dataConfigBiz from '@/logic/intelligentMonitor/dataConfigBiz'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        handleForm: {
          name: '',
          type: ''
        },
        rules: {
          name: [
            { required: true, message: `${this.$t('common.entryTips')}${this.$t('dataConfig.name')}` }
          ]
        },
        select_type: {}
      }
    },
    components: {
      dial
    },
    methods: {
      init () {
        if (this.$route.query.id) {
          this.getSourceType(true)
        } else {
          this.getSourceType()
          this.setHistory()
          this.$refs.dataConfigDial.resetRequestList()
          this.$refs.handleForm.clearValidate()
          this.$refs.handleForm.resetFields()
        }
      },
      async getSourceType (isEdit = false) {
        await this.dGetDictionaryByCode('dataType')
        this.select_type = { ...this.dDictionary.dataType }
        this.handleForm.type = Object.keys(this.select_type)[0]
        if (isEdit) this.getSourceDataById()
      },
      setHistory (name) {
        this.history = []
        this.history.push({ name: name || this.$t('dataConfig.addDataSource') })
      },
      getSourceDataById () {
        dataConfigBiz.findSourceById({ id: this.$route.query.id }).then(data => {
          this.setHistory(data.name)
          this.handleForm.name = data.name
          this.handleForm.type = data.type
          if (data.requestList) this.$refs.dataConfigDial.setRequestList(data.requestList)
        })
      },
      testSingleDial (obj) {
        if (obj.requestInfo) {
          let params = {
            condition: this.handleForm.condition ? JSON.parse(this.handleForm.condition) : JSON.parse('{}'),
            requestList: [{ ...obj.requestInfo }]
          }
          dialBiz.testall({ ...params }).then(data => {
            if (typeof data === 'object') data = JSON.stringify(data)
            this.$refs.dataConfigDial.setResponse(obj.requestIndex, data)
            this.successMessage()
          })
        }
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      },
      saveSource () {
        this.$refs['handleForm'].validate((valid) => {
          if (valid && this.$refs.dataConfigDial.getRequestList()) {
            let id = this.$route.query.id
            let eventName = id ? 'updateSource' : 'addSource'
            let saveObj = extend(true, { requestList: this.$refs.dataConfigDial.getRequestList() }, this.handleForm)
            if (id) saveObj.id = id
            dataConfigBiz[eventName](saveObj).then(data => {
              this.successMessage()
              this.$router.push({ name: 'dataConfig' })
            })
          } else {
            return false
          }
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'handlerDataConfig' && from.name === 'dataConfig') {
          this.init()
        }
      }
    },
    mounted () {
      this.init()
    }
  }
</script>

<style>

</style>